<template>
  <div class="policy-sivi-messages">
    <content-loader v-if="loading"
                    :width="500"
                    :height="30"
                    :speed="2"
                    :animate="true"
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                    style="width:100%;">
      <rect x="0" y="0" rx="0" ry="0" width="500" height="30"/>
    </content-loader>
    <a-collapse v-if="!loading && hasMessages">
      <a-collapse-panel v-for="(year) in groupedAFDMessagesSortedIdices"
                        :key="year">
        <template slot="header">
          <a-badge :count="groupedAFDMessages[year].length" style="float: right;margin-right: 1.5rem;"/>
          <div>{{ year }}</div>
        </template>
        <a-collapse>
          <a-collapse-panel v-for="(afdMessage, index) in groupedAFDMessages[year]"
                            :header="getTitle(afdMessage)"
                            :key="afdMessage.id">
            <SiviMessageComponent v-bind:afd-message-id="afdMessage.id" :can-reapply-to-policy="true"></SiviMessageComponent>
          </a-collapse-panel>
        </a-collapse>
      </a-collapse-panel>
    </a-collapse>
    <div v-if="!loading && !hasMessages">
      <p>Polis heeft geen ADN berichten</p>
    </div>
  </div>
</template>

<script>
import SiviMessageComponent from "../../sivi/components/SiviMessageComponent";
import afdMessageApi from "~/api/afd_message";
import { ContentLoader } from "vue-content-loader";

const moment = require('moment')

export default {
  name: 'PolicySiviMessagesComponent',
  components: { SiviMessageComponent, ContentLoader },
  props: {
    policyId: {
      type: String,
      required: true
    },
  },
  data () {
    return {
      afdMessages: [],
      loading: true,
    }
  },
  computed: {
    groupedAFDMessages () {
      return this.afdMessages.reduce(function (rv, x) {
        let date = moment(x['datetime'], moment.ISO_8601);
        (rv[date.year()] = rv[date.year()] || []).push(x)
        return rv
      }, {})
    },
    hasMessages () {
      return this.afdMessages.length > 0
    },
    groupedAFDMessagesSortedIdices () {
      if (typeof this.groupedAFDMessages !== 'undefined' && this.groupedAFDMessages !== null) {
        return Object.keys(this.groupedAFDMessages).sort(function (a, b) {
          return b - a
        })
      }
    }
  },
  methods: {
    loadAfdMessages () {
      afdMessageApi.getByPolicyId(this.policyId).then(response => {
        this.loading = false
        this.afdMessages = response.data
        this.loadSiviMessages()
      }).catch(error => {
        this.loading = false
      })
    },
    loadSiviMessages () {
      // for (let afdMessageKey in this.afdMessages) {
      //   siviApi.getByAfdMessageId(this.afdMessages[afdMessageKey].id).then((data) => {
      //     Vue.set(this.afdMessages[afdMessageKey], 'siviMessage', data.data);
      //   });
      // }
    },
    getYear (date) {
      let d = moment(date, moment.ISO_8601)
      return d.year()
    },
    getTitle (afdMessage) {
      let date = moment(afdMessage.datetime, moment.ISO_8601)
      let messageTitle = afdMessage.type_description + ' ' + date.format('D/M/Y')
      let attributes = this.getAttributesFromMessageByLabel(afdMessage.siviMessage, 'BYLSRT')

      if (attributes.length > 0) {
        messageTitle += ' (' + attributes.map(attribute => attribute.codeListDescription).join(', ') + ') '
      }

      return messageTitle
    },
    getMessageTitle (message) {
      let messageTitle = message.label
      let attributes = this.getAttributesFromMessageByLabel(message, 'BYLSRT')

      if (attributes.length > 0) {
        messageTitle += ' (' + attributes.map(attribute => attribute.codeListDescription).join(', ') + ') '
      }

      return messageTitle
    },
    getAttributesFromEntityByLabel (entity, label) {
      let attributes = []
      for (let attributeKey in entity.attributes) {
        let attribute = entity.attributes[attributeKey]

        if (attribute.label === label) {
          attributes.push(attribute)
        }
      }

      if (entity.entities && typeof entity.entities !== 'undefined' && Array.isArray(entity.entities)) {
        for (let entityKey in entity.entities) {
          let subEntity = entity.entities[entityKey]
          attributes = attributes.concat(this.getAttributesFromEntityByLabel(subEntity, label))
        }
      }

      return attributes
    },
    getAttributesFromMessageByLabel (message, label) {
      let attributes = []
      if (typeof message !== 'undefined') {
        if (message.entities && typeof message.entities !== 'undefined' && Array.isArray(message.entities)) {
          for (let entityKey in message.entities) {
            let entity = message.entities[entityKey]
            attributes = attributes.concat(this.getAttributesFromEntityByLabel(entity, label))
          }
        }

        if (typeof message.subMessages !== 'undefined' && Array.isArray(message.subMessages)) {
          for (let subMessageKey in message.subMessages) {
            let subMessage = message.subMessages[subMessageKey]
            attributes = attributes.concat(this.getAttributesFromMessageByLabel(subMessage, label))
          }
        }
      }

      return attributes
    },
  },
  mounted () {
    this.loadAfdMessages()
  }
}
</script>
<style scoped>
.policy-sivi-messages > .ant-collapse > .ant-collapse-item > .ant-collapse-header {
  background-color: #6ccbd7;
  border-bottom-color: #38b9c9;
  color: white;
}
</style>
